import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";
import { Text } from "$components";
import { DockyardStatus } from "$types/DockyardStatus";
import { DOCKYARD_STATUS_LABELS } from "$utils/typeConstants/Dockyard";

type Props = {
  disabled?: boolean;
  status: DockyardStatus;
};

function DockyardStatusBadge({
  disabled = false,
  status = DockyardStatus.IN_PROGRESS,
}: Props) {
  const classes = useStyles();
  let text;
  let cls;

  // Normalize status to handle both uppercase and lowercase values
  const normalizedStatus = status?.toLowerCase();

  switch (normalizedStatus) {
    case DockyardStatus.IN_PROGRESS:
      text = DOCKYARD_STATUS_LABELS[DockyardStatus.IN_PROGRESS];
      cls = `${disabled ? classes.disabled : classes.progress} `;
      break;
    case DockyardStatus.DONE:
      text = DOCKYARD_STATUS_LABELS[DockyardStatus.DONE];
      cls = `${disabled ? classes.disabled : classes.done}`;
      break;
    default:
      console.error(`Invalid status / dockyard status for Badge: ${status}`);
      // Fallback to IN_PROGRESS for unknown statuses
      text = DOCKYARD_STATUS_LABELS[DockyardStatus.IN_PROGRESS];
      cls = `${disabled ? classes.disabled : classes.progress} `;
  }
  return (
    <span className={`${classes.badge} ${cls}`}>
      <Text className={classes.text}>{text}</Text>
    </span>
  );
}
export default DockyardStatusBadge;

const useStyles = createUseStyles(() => ({
  badge: {
    padding: "2px",
    borderRadius: "2px",
  },
  text: {
    color: theme.color.white,
  },
  done: {
    backgroundColor: theme.color.green,
    "&.disabled": {
      backgroundColor: theme.color.gray3,
    },
  },
  progress: {
    backgroundColor: theme.color.blueLight,
    "&.disabled": {
      backgroundColor: theme.color.gray3,
    },
  },
  disabled: {
    backgroundColor: theme.color.gray3,
  },
}));
